export enum PIPELINE_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PAUSED = 'PAUSED',
  DRAFT = 'DRAFT',
}

export const PIPELINE_STATUS_CLASSNAMES = {
  [PIPELINE_STATUS.ACTIVE]: 'bg-green-100 text-green-800',
  [PIPELINE_STATUS.INACTIVE]: 'bg-gray-100 text-gray-800',
  [PIPELINE_STATUS.PAUSED]: 'bg-yellow-100 text-yellow-800',
  [PIPELINE_STATUS.DRAFT]: 'bg-gray-100 text-gray-800',
};

export enum PIPELINE_RUNTIME_STATUS {
  STARTING = 'STARTING',
  RUNNING = 'RUNNING',
  FAILING = 'FAILING',
  TERMINATED = 'TERMINATED',
  RESTARTING = 'RESTARTING',
}

export const PIPELINE_RUNTIME_STATUS_CLASSNAMES = {
  [PIPELINE_RUNTIME_STATUS.STARTING]: 'bg-blue-100 text-blue-800',
  [PIPELINE_RUNTIME_STATUS.RUNNING]: 'bg-green-100 text-green-800',
  [PIPELINE_RUNTIME_STATUS.FAILING]: 'bg-red-100 text-red-800',
  [PIPELINE_RUNTIME_STATUS.TERMINATED]: 'bg-black-100 text-black-800',
  [PIPELINE_RUNTIME_STATUS.RESTARTING]: 'bg-yellow-100 text-yellow-800',
};
